import styled from "styled-components"

export const MarginTop = styled.div`
  margin-top: 10px;
`
